import styled from 'styled-components';

import { COLOR_CONFIG } from 'constants/color';

export const FunctionalAbilityTableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border: 1px solid ${COLOR_CONFIG['white-smoke']};
  border-radius: 12px;
  background: ${COLOR_CONFIG['white-smoke']};
`;

export const FunctionalAbilityTableBody = styled.div<{ $bgColor: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 27px 16px;
  cursor: pointer;
  border-radius: 12px;
  background: ${(props) => props.$bgColor};
`;
